"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormTelefonos = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _PhoneAndroid = _interopRequireDefault(require("@mui/icons-material/PhoneAndroid"));

var _Phone = _interopRequireDefault(require("@mui/icons-material/Phone"));

var _MoreVert = _interopRequireDefault(require("@mui/icons-material/MoreVert"));

var _WhatsApp = _interopRequireDefault(require("@mui/icons-material/WhatsApp"));

var _libphonenumberJs = _interopRequireDefault(require("libphonenumber-js"));

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormTelefonos extends _react.default.Component {
  constructor(props) {
    super(props);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleChangeCheck = this.handleChangeCheck.bind(this);
    this.handleOpenMenu = this.handleOpenMenu.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.agregarTelefono = this.agregarTelefono.bind(this);
    this.abrirInputsTelefono = this.abrirInputsTelefono.bind(this);
    this.handleChangeWhatsapp = this.handleChangeWhatsapp.bind(this);
    this.handleEliminarTelefono = this.handleEliminarTelefono.bind(this);
    this.handleChangeObservacion = this.handleChangeObservacion.bind(this);
    this.editarObservacion = this.editarObservacion.bind(this);
    this.validatePhone = this.validatePhone.bind(this);
    this.openModalConfirm = this.openModalConfirm.bind(this);
    this.hideModalConfirm = this.hideModalConfirm.bind(this);
    this.handleChangeCaracteristica = this.handleChangeCaracteristica.bind(this);
    this.handleChangeNumero = this.handleChangeNumero.bind(this);
    this.cargarTelefono = this.cargarTelefono.bind(this);
    this.state = {
      inputsOpen: true,
      selectTelefono: 'Celular',
      wsp: 1,
      anclaMenu: null,
      idEditarObservacion: null,
      indexPositionObservacion: 0,
      telefonos: this.props.telefonos ? this.props.telefonos : [],
      errorCaracteristica: false,
      errorNumero: false,
      openModal: false,
      idTelAEliminar: '',
      changeValueInput: false,
      id: null
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.telefonos != this.props.telefonos) {
      this.setState({
        telefonos: this.props.telefonos
      });
    }
  }

  handleOpenMenu(event) {
    this.setState({
      anclaMenu: event.currentTarget
    });
  }

  handleCloseMenu() {
    this.setState({
      anclaMenu: null
    });
  }

  handleChangeSelect(event) {
    const selectValue = event.target.value;
    this.setState({
      wsp: selectValue === 'Celular' ? 1 : 0,
      selectTelefono: selectValue,
      changeValueInput: true
    }, () => {
      this.cargarTelefono();
    });
  }

  handleChangeCheck(event) {
    this.setState({
      wsp: event.target.checked ? 1 : 0
    }, () => {
      this.cargarTelefono();
    });
  }

  validatePhone(caracteristica, telefono) {
    const caractONumVacio = !this.inputRefCaract.value || !this.inputRefNumero.value; //si se cambia el valor del numero o caracteristica y alguno de los dos esta vacio muestro alerta

    if (this.state.changeValueInput && caractONumVacio) {
      this.setState({
        errorCaracteristica: this.inputRefCaract.value ? false : true,
        errorNumero: this.inputRefNumero.value ? false : true
      });
      alert('faltan datos por completar del telefono');
      return false;
    }

    const validarTelefono = (0, _libphonenumberJs.default)(caracteristica + telefono, 'AR');

    if (validarTelefono && !validarTelefono.isPossible() && !validarTelefono.isValid()) {
      this.setState({
        errorCaracteristica: true,
        errorNumero: true
      });
      alert('La característica o el número de teléfono ingresado no son válidos');
      return false;
    }

    return true;
  }

  agregarTelefono() {
    if (!this.validatePhone(this.inputRefCaract.value, this.inputRefNumero.value)) {
      return;
    } //si no hago ningun cambio en el input de numero o caract no agrego telefono


    if (!this.state.changeValueInput) {
      return;
    }

    const telefono = {
      id: this.state.id,
      es_celular: this.selectRefTipo.value == 'Celular' ? 1 : 0,
      caracteristica: this.inputRefCaract.value,
      telefono: this.inputRefNumero.value,
      observaciones: this.inputRefObservacion.value,
      tiene_ws: this.state.wsp,
      ocultar: false
    };
    this.setState({
      selectTelefono: 'Celular',
      wsp: 1,
      inputsOpen: false,
      errorCaracteristica: false,
      errorNumero: false,
      changeValueInput: false,
      id: null
    }, () => {
      this.inputRefCaract.value = '';
      this.inputRefNumero.value = '';
      this.inputRefObservacion.value = '';
      this.props.onChange(1, telefono);
    });
  }

  abrirInputsTelefono() {
    this.setState({
      inputsOpen: true
    });
  }

  handleChangeWhatsapp(event) {
    const telefonoId = event.target.getAttribute('data-telefonoid'); //const posicionTelefonoEnArray = event.target.getAttribute('data-posicion');

    const tieneWsp = event.target.getAttribute('data-tiene') == 1;
    let telefonosAEditar = this.state.telefonos;
    let telefonoAEditar = telefonosAEditar.find(tel => tel.id == telefonoId);
    let telefonoEditado = { ...telefonoAEditar,
      tiene_ws: tieneWsp ? 1 : 0,
      edit: 1
    };
    this.props.onChange(1, telefonoEditado);
    /*const telefono = {
        id: telAEditarWsp[0].id,
        es_celular: telAEditarWsp[0].es_celular,
        caracteristica: telAEditarWsp[0].caracteristica,
        telefono: telAEditarWsp[0].telefono,
        observacion: telAEditarWsp[0].observacion,
        tiene_ws: tieneWsp,
    };
     const arraySinTelAEditarWsp = this.state.telefonos.filter(tel => tel.id != telefonoId);
    arraySinTelAEditarWsp.splice(posicionTelefonoEnArray, 0, telefono);
     this.setState({
        telefonos: arraySinTelAEditarWsp
    })
    this.handleCloseMenu();*/

    this.handleCloseMenu();
  }

  handleEliminarTelefono() {
    let telefonosAEditar = this.state.telefonos;

    if (!(telefonosAEditar.length - 1)) {
      this.abrirInputsTelefono();
    }

    const telEliminado = telefonosAEditar.find(tel => tel.id == this.state.idTelAEliminar);
    let telefonoConDelete = { ...telEliminado,
      delete: 1
    };
    this.setState({
      openModal: false
    }, () => this.props.onChange(1, telefonoConDelete));
    this.handleCloseMenu();
  }

  handleChangeObservacion(event) {
    const telefonoId = this.state.idEditarObservacion;
    const posicionTelefonoEnArray = this.state.indexPositionObservacion;
    const telAEditarObservacion = this.state.telefonos.filter(tel => tel.id == telefonoId);
    const telefono = {
      id: telAEditarObservacion[0].id,
      es_celular: telAEditarObservacion[0].es_celular ? 1 : 0,
      caracteristica: telAEditarObservacion[0].caracteristica,
      telefono: telAEditarObservacion[0].telefono,
      observaciones: event.target.value,
      tiene_ws: telAEditarObservacion[0].tiene_ws,
      edit: 1
    };
    this.props.onChange(1, telefono);
    const arraySinTelAEditarObservacion = this.state.telefonos.filter(tel => tel.id != telefonoId);
    arraySinTelAEditarObservacion.splice(posicionTelefonoEnArray, 0, telefono);
    this.setState({
      telefonos: arraySinTelAEditarObservacion,
      idEditarObservacion: null
    });
  }

  editarObservacion(event) {
    this.setState({
      idEditarObservacion: event.target.getAttribute('data-telefonoid'),
      indexPositionObservacion: event.target.getAttribute('data-posicion')
    });
    this.handleCloseMenu();
  }

  openModalConfirm(event) {
    const idTelefonoAEliminar = event.target.getAttribute('data-telefonoid');
    this.setState({
      openModal: true,
      idTelAEliminar: idTelefonoAEliminar
    });
  }

  hideModalConfirm() {
    this.setState({
      openModal: false
    });
  }

  handleChangeCaracteristica(event) {
    this.setState({
      changeValueInput: !!event.target.value,
      errorCaracteristica: !!!event.target.value
    }, () => {
      this.cargarTelefono();
    });
  }

  handleChangeNumero(event) {
    this.setState({
      changeValueInput: !!event.target.value,
      errorNumero: !!!event.target.value
    }, () => {
      this.cargarTelefono();
    });
  }

  cargarTelefono() {
    if (this.state.id) {
      const telefono = {
        id: this.state.id,
        es_celular: this.selectRefTipo.value == 'Celular' ? 1 : 0,
        caracteristica: this.inputRefCaract.value,
        telefono: this.inputRefNumero.value,
        observaciones: this.inputRefObservacion.value,
        tiene_ws: this.state.wsp,
        ocultar: true
      };
      this.props.onChange(1, telefono);
    } else {
      const telefono = {
        id: "new" + ("" + Math.random()).substring(2, 10),
        es_celular: this.selectRefTipo.value == 'Celular' ? 1 : 0,
        caracteristica: this.inputRefCaract.value,
        telefono: this.inputRefNumero.value,
        observaciones: this.inputRefObservacion.value,
        tiene_ws: this.state.wsp,
        ocultar: true
      };
      this.setState({
        id: telefono.id
      }, () => {
        this.props.onChange(0, telefono);
      });
    }
  }

  render() {
    const {
      selectTelefono,
      wsp,
      anclaMenu,
      inputsOpen,
      idEditarObservacion,
      telefonos,
      openModal,
      errorCaracteristica,
      errorNumero
    } = this.state;
    return (0, _react2.jsx)("div", {
      css: _style.default.telefonosContainer
    }, (0, _react2.jsx)(_material.Grid, null, (0, _react2.jsx)(_material.Typography, {
      component: "h1"
    }, (0, _react2.jsx)(_material.Box, {
      fontWeight: "fontWeightBold",
      fontSize: "subtitle1",
      mb: 3
    }, "Tel\xE9fonos Celulares y Fijo")), telefonos.map((telefono, index) => {
      return telefono.ocultar ? null : (0, _react2.jsx)(_material.List, {
        key: telefono.id
      }, (0, _react2.jsx)(_material.ListItem, null, (0, _react2.jsx)(_material.ListItemIcon, {
        css: _style.default.phoneIcon
      }, telefono.es_celular == 1 ? (0, _react2.jsx)(_PhoneAndroid.default, {
        css: _style.default.colorCeleste
      }) : (0, _react2.jsx)(_Phone.default, {
        css: _style.default.colorCeleste
      })), (0, _react2.jsx)(_material.ListItemText, {
        primary: (0, _react2.jsx)(_material.Typography, {
          css: _style.default.display
        }, `(${telefono.caracteristica}) ${telefono.telefono}`, telefono.tiene_ws == 1 ? (0, _react2.jsx)(_WhatsApp.default, {
          css: _style.default.wspIcon
        }) : null),
        secondary: idEditarObservacion != telefono.id ? (0, _react2.jsx)(_material.Typography, {
          variant: "caption"
        }, telefono.observaciones) : null
      }), (0, _react2.jsx)(_material.ListItemSecondaryAction, null, (0, _react2.jsx)(_material.IconButton, {
        "aria-label": "More",
        "aria-owns": 'long-menu',
        "aria-haspopup": "true",
        "data-telefonoid": telefono.id,
        onClick: this.handleOpenMenu
      }, (0, _react2.jsx)(_MoreVert.default, null)), (0, _react2.jsx)(_material.Menu, {
        anchorEl: anclaMenu,
        open: anclaMenu ? anclaMenu.getAttribute('data-telefonoid') == telefono.id : false,
        onClose: this.handleCloseMenu
      }, (0, _react2.jsx)(_material.MenuItem, {
        "data-posicion": index,
        "data-telefonoid": telefono.id,
        onClick: this.editarObservacion
      }, "Editar observaci\xF3n"), telefono.es_celular ? (0, _react2.jsx)(_material.MenuItem, {
        "data-posicion": index,
        "data-telefonoid": telefono.id,
        "data-tiene": telefono.tiene_ws == 1 ? 0 : 1,
        onClick: this.handleChangeWhatsapp
      }, telefono.tiene_ws == 1 ? 'Deshabilitar WhatsApp' : 'Habilitar WhatsApp') : null, (0, _react2.jsx)(_material.MenuItem, {
        "data-telefonoid": telefono.id,
        onClick: this.openModalConfirm
      }, "Eliminar")))), (0, _react2.jsx)(_material.Collapse, {
        in: idEditarObservacion == telefono.id,
        onEntered: () => this[`telefono${telefono.id}`].focus()
      }, (0, _react2.jsx)(_material.ListItem, null, (0, _react2.jsx)(_material.Input, {
        type: "text",
        id: `nueva-observacion-${telefono.id}`,
        fullWidth: true,
        defaultValue: telefono.observaciones,
        inputRef: ref => {
          this[`telefono${telefono.id}`] = ref;
        },
        onBlur: this.handleChangeObservacion
      }))));
    }), (0, _react2.jsx)(_material.Collapse, {
      in: inputsOpen
    }, (0, _react2.jsx)(_material.Grid, {
      container: true,
      justifyContent: "space-between"
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      sm: 3,
      xs: 3
    }, (0, _react2.jsx)(_material.FormControl, {
      css: _style.default.selectTel
    }, (0, _react2.jsx)(_material.TextField, {
      select: true,
      variant: "standard",
      value: selectTelefono,
      onChange: this.handleChangeSelect,
      inputRef: ref => {
        this.selectRefTipo = ref;
      },
      SelectProps: {
        MenuProps: {
          disablePortal: true
        }
      }
    }, (0, _react2.jsx)(_material.MenuItem, {
      value: "Celular"
    }, "Celular"), (0, _react2.jsx)(_material.MenuItem, {
      value: "Fijo"
    }, "Fijo")))), (0, _react2.jsx)(_material.Grid, {
      item: true,
      sm: 2,
      xs: 2
    }, (0, _react2.jsx)(_material.TextField, {
      label: "Caract",
      variant: "standard",
      type: "number",
      placeholder: "sin 0",
      error: errorCaracteristica,
      onBlur: this.handleChangeCaracteristica,
      inputRef: ref => {
        this.inputRefCaract = ref;
      },
      fullWidth: true
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      sm: 6,
      xs: 6
    }, (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "N\xFAmero",
      type: "number",
      placeholder: "sin 15",
      error: errorNumero,
      onBlur: this.handleChangeNumero,
      inputRef: ref => {
        this.inputRefNumero = ref;
      },
      fullWidth: true
    }))), (0, _react2.jsx)(_material.Grid, {
      container: true,
      justifyContent: "space-between",
      css: _style.default.margen
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      sm: 7,
      xs: 7
    }, (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "Observaci\xF3n",
      onBlur: this.cargarTelefono,
      inputRef: ref => {
        this.inputRefObservacion = ref;
      },
      fullWidth: true
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      sm: 4,
      xs: 4,
      css: _style.default.gridWhatsapp
    }, (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.checkWhatsapp,
      control: (0, _react2.jsx)(_material.Checkbox, {
        checked: !!wsp,
        onChange: this.handleChangeCheck,
        value: "wsp",
        disabled: selectTelefono !== 'Celular',
        color: "primary"
      }),
      label: "WhatsApp"
    })))), (0, _react2.jsx)(_material.Dialog, {
      open: openModal,
      onClose: this.hideModalConfirm
    }, (0, _react2.jsx)(_material.DialogContent, null, (0, _react2.jsx)(_material.DialogContentText, {
      id: "alert-dialog-description"
    }, "\xBFEst\xE1 seguro que desea eliminar este tel\xE9fono?")), (0, _react2.jsx)(_material.DialogActions, null, (0, _react2.jsx)(_material.Button, {
      onClick: this.hideModalConfirm,
      css: _style.default.colorCeleste
    }, "Cancelar"), (0, _react2.jsx)(_material.Button, {
      onClick: this.handleEliminarTelefono,
      css: _style.default.colorCeleste,
      autoFocus: true
    }, "Aceptar"))), (0, _react2.jsx)(_material.Grid, {
      container: true,
      justifyContent: "flex-end"
    }, inputsOpen ? (0, _react2.jsx)(_material.Button, {
      css: _style.default.colorCeleste,
      size: "small",
      onClick: this.agregarTelefono
    }, "Guardar tel\xE9fono") : (0, _react2.jsx)(_material.Button, {
      css: _style.default.colorCeleste,
      size: "small",
      onClick: this.abrirInputsTelefono
    }, "+ Agregar otro tel\xE9fono"))));
  }

}

exports.FormTelefonos = FormTelefonos;
var _default = FormTelefonos;
exports.default = _default;